/* RCF Minibikes theme */
(function () {
  document.documentElement.classList.remove('no-js');

  /* Mobile menu */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* Hero slider */
  function initSlider(root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) * 1000;
    function go(i) {
      index = (i + slides.length) % slides.length;
      for (var n = 0; n < slides.length; n++) {
        slides[n].classList.toggle('is-active', n === index);
        if (dots[n]) dots[n].classList.toggle('is-active', n === index);
      }
    }
    function start() {
      if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stop();
        timer = setInterval(function () { go(index + 1); }, delay);
      }
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function (e) {
        go(parseInt(e.currentTarget.getAttribute('data-dot'), 10));
        start();
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    start();
    // Theme editor: jump to the selected slide block.
    document.addEventListener('shopify:block:select', function (e) {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n] === e.target) { stop(); go(n); }
      }
    });
  }
  var sliders = document.querySelectorAll('[data-slider]');
  for (var s = 0; s < sliders.length; s++) initSlider(sliders[s]);

  /* Video header: pause/play button, and respect reduced motion */
  var vheros = document.querySelectorAll('[data-vhero]');
  for (var h = 0; h < vheros.length; h++) {
    (function (root) {
      var video = root.querySelector('video');
      var btn = root.querySelector('[data-vhero-toggle]');
      if (!video) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Play video');
        }
      });
    })(vheros[h]);
  }

  /* Product page */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  var product = document.querySelector('[data-product]');
  if (product) {
    var form = product.querySelector('[data-product-form]');
    var jsonEl = product.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var idInput = product.querySelector('[data-variant-id]');
    var priceEl = product.querySelector('[data-price]');
    var addBtn = product.querySelector('[data-add-button]');
    var mainMedia = product.querySelector('[data-main-media]');

    function selectedOptions() {
      var groups = product.querySelectorAll('.option');
      var values = [];
      for (var g = 0; g < groups.length; g++) {
        var checked = groups[g].querySelector('input:checked');
        values.push(checked ? checked.value : null);
      }
      return values;
    }
    function update() {
      var opts = selectedOptions();
      var match = null;
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < opts.length; o++) {
          if (variants[v].options[o] !== opts[o]) { ok = false; break; }
        }
        if (ok) { match = variants[v]; break; }
      }
      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      var html = money(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) html += '<s>' + money(match.compare_at_price) + '</s>';
      priceEl.innerHTML = html;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      if (match.featured_image && mainMedia) {
        var img = mainMedia.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = match.featured_image.src; }
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var radios = product.querySelectorAll('.option input');
    for (var r = 0; r < radios.length; r++) radios[r].addEventListener('change', update);

    var qtyInput = product.querySelector('input[name="quantity"]');
    var qtyBtns = product.querySelectorAll('[data-qty]');
    for (var q = 0; q < qtyBtns.length; q++) {
      qtyBtns[q].addEventListener('click', function (e) {
        var step = parseInt(e.currentTarget.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      });
    }

    var thumbs = product.querySelectorAll('[data-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var img = mainMedia.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.src = btn.getAttribute('data-thumb');
          img.alt = btn.getAttribute('data-alt');
        }
        for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-active', thumbs[k] === btn);
      });
    }
  }

  /* Collection sort */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
